
/**
 * JavaScript React Framework
 */
import React from 'react';
// import ReactDom from 'react-dom';

/**
 * React-Bootstrap
 */ 
import { Jumbotron, Thumbnail, Modal, ListGroup, ListGroupItem, Button, Grid, Row, Col } from 'react-bootstrap';

/**
 * Cascading StyleSheets
 */
 import 'bootstrap/dist/css/bootstrap.min.css';
 import '../../../assets/css/App.css';
 
/**
 * Internal Application Components 
 */
import MarketingBlock from '../../common/content/MarketingBlock.js';

import pdf_01 from "../../../assets/pdf/manuscript/BrownTS_5PageWritingSample.pdf";

import imgHeader_01 from '../../../assets/img/karna/UAMedicalResearch.jpg';
import imgHeader_02 from '../../../assets/img/karna/UAKeating.jpg';
import imgHeader_03 from '../../../assets/img/karna/karna_crypto.png';
import imgHeader_04 from '../../../assets/img/karna/karna_depth.png';
import imgHeader_05 from '../../../assets/img/karna/karna_10.png';
import imgHeader_06 from '../../../assets/img/karna/BallMill.jpg';
import imgHeader_07 from '../../../assets/img/karna/Flotation.jpg';
import imgHeader_08 from '../../../assets/img/karna/karna_pearson.png';
import imgHeader_09 from '../../../assets/img/karna/karna_spearman.png';
import imgHeader_10 from '../../../assets/img/karna/karna_stemleaf.png';
import imgHeader_11 from '../../../assets/img/karna/karna_leonardo.png';

let fontSize = {fontSize: '1.10em'};

/**
 * Note: Your components tell React what you want to render
 */
class KarnaRam extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showUnicityDistance: false,
    	showDepth: false,
    	showDiphthongs: false
		}
	}

  showUnicityDistance() {
    this.setState({
    	showUnicityDistance: true
    });
  }

  showDepth() {
    this.setState({
    	showDepth: true
    });
  }

  showDiphthongs() {
    this.setState({
    	showDiphthongs: true
    });
  }

  hideUnicityDistance() {
    this.setState({ 
    	showUnicityDistance: false 
    });
  }

  hideDepth() {
    this.setState({ 
    	showDepth: false 
    });
  }

  hideDiphthongs() {
    this.setState({
    	showDiphthongs: false
    });
  }

	render() {
		return (
			<div id="Karna-Ram">
				<Jumbotron>
	          <div>
	          	<Grid>
				    		<div className="well">
					    		<Row>
					    			<Col xs={12} md={12}>
					    				<center>
						    				<MarketingBlock header="Karna-Ram">
						    					Informatics through Cryptology: Desktop informatics software to help scientists, clinicians, engineers, and data scientists investigate relationships between variables. The project is being pursued through the powerful lens of cryptology as an innovative way to interpret data and relationships therein; for example, imagine the rotors of a cipher machine being the disease markers of a cipher text. Intellectual property includes custom rapid analytical machines (RAM) for the brute force modeling of significant data points.
						    				</MarketingBlock>
					    				</center>
					    			</Col>
					    		</Row>

					    		<Row>
					    			<Col xs={12} md={6}>
					    				<Thumbnail className="img-responsive center-block img-fluid" src={imgHeader_01}>
					    				<h3>Problem statement</h3>
							          <p className="text-justify" style={fontSize}>Not all scientists have access to a statistician all the time and most scientists do not have brute force methods of modeling data. All scientists need investigative tools. Karna-Ram is an investigative tool to help scientists interpret data, investigate relationships and highlight variable cryptologic uncertainty.</p>
					    				</Thumbnail>
					    			</Col>

					    			<Col xs={12} md={6}>
					    				<Thumbnail className="img-responsive center-block img-fluid" src={imgHeader_02}>
					    				<h3>Hypothesis/Thesis</h3>
							          <p className="text-justify" style={fontSize}>Informatics, the raw data of presenting patients, provides both the salient and most notable concern but moreover the markers of a hidden concern. The hypothesis for this project is that there is always a hidden concern within the presentation of biomedical data that cryptology can aid in discovery.</p>
					    				</Thumbnail>
					    			</Col>
					    		</Row>

					    		<Row>
					    			<Col xs={12} md={12}>
					    				<Thumbnail>
					    				<h3>Medicine and Cryptology</h3>
							          <p className="text-justify" style={fontSize}>"Cryptography can solve a lot of problems that most people never realized it could ... few practical algorithms are absolutely impervious to analysis; all manner of characteristics might serve as entering wedges to crack some encrypted message." - <a href="https://en.wikipedia.org/wiki/Bruce_Schneier">Bruce Schneier</a> [1] (xxii, 236) - in a world where observable data can be measured, a cryptosystem can be built around each domain in that world.</p>
					    				</Thumbnail>
					    			</Col>
					    		</Row>
				    		</div>
				    	</Grid>
	          </div>
				</Jumbotron>

				<Grid className="blockpadding">
					<Row>
	    			<Col xs={12} md={12}>
	    				<center>
		    				<MarketingBlock header="About the Project">
		    					<span className="lead">
		    						The project code-name: Karna-Ram, is derived from ribonucleic acid (RNA) and rapid analytical machinery (RAM). <a href="https://en.wikipedia.org/wiki/Karna">Karna</a> is a Hindu mythological warrior figure known for his famous impenetrable armor and noted by his sacrifice, courage, charity, valor, and selflessness. The initial prototype of this project code-named Project-<a href="https://en.wikipedia.org/wiki/Asclepius">Asclepius</a>, re-invented as a standalone project and reclassified as Karna-Ram, began at the University of Arizona with inspiration from a focused technology research and development grant solicitation specifically requesting proposals for innovative informatics technology projects.
		    					</span>
		    					<hr/>
		    					<span style={fontSize}>
		    						Intellectual property includes custom rapid analytical machines (RAMs) for brute force modeling significant data points. This software is intended to serve as an investigative tool allowing scientists an alternate lens to view and interpret their data; this is not general purpose statistics software. As a lens, biases will become more salient as a means to reintroduce potential insight; for example, from a cryptographic standpoint frequency is both very important and simultaneously misleading as the same measurement might represent different things; for example, fundamentally different diagnoses.
		    					</span>
									<hr/>
		              <span style={fontSize}>
		              	Much of the initial conceptual design began during my work in <a href={pdf_01}>de-identification</a> at the University of Arizona. A special thank you to the directors who helped sponsor my work: the <a href="http://cb2.uahs.arizona.edu/">Center for Biomedical Informatics and Biostatistics</a>, the <a href="http://pophealth.uahs.arizona.edu/">Center for Population Science and Discovery</a>, and the <a href="http://www.labmedinfo.org/">Laboratory for Biomedical Informatics</a> "Mario Stefanelli" at University of Pavia. <em>The initial prototype was built to foster a collaborative relationship between the University of Pavia and the University of Arizona</em>.
		              </span>
		              <hr/>
		    					<span style={fontSize}>
		    						A special thanks to the directors, cast, and crew of the very successful History sponsored show: <a href="http://www.history.com/shows/ancient-aliens">Ancient Aliens</a>. The continued development of this project was spurred by an episode where the mythological figure Karna was illustrated.
		    					</span>
		    				</MarketingBlock>
	    				</center>
	    			</Col>
	    		</Row>

	    		<div className="well">
		    		<Row>
		    			<Col xs={12} md={12}>
		    				<center>
			    				<MarketingBlock header="Rapid Analytical Machines (the heart of Karna-Ram)">
			    					<span className="lead">The purpose of a rapid analytical machine is to apply a specific lens to a set of data. This lens will set a specific bias; for example, by weighting an algorithm toward higher frequency values, the RAM has set a bias for the scientist to use in his or her interpretation of the data. An artifact of using this lens is the illumination of existing preconceived perceptions of how the data should behave. The strengths in the presented approach is to help identify new relationships between measurements by imposing a new and creative view into existing data.</span>
			    				</MarketingBlock>
		    				</center>
		    			</Col>
		    		</Row>

		    		<Row>
		    			<Col xs={12} md={6}>
		    				<Thumbnail className="img-responsive center-block img-fluid" src={imgHeader_06}>
		    				<h3>Leonardo da Vinci</h3>
				          <p className="text-justify" style={fontSize}>Leonardo da Vinci looks to minimize a Chi-Statistic by taking each measurement as categorical values and measuring each observed value in the dataset against every other observed value (as the expected value). This algorithm is enhanced by highlighting the differences between frequencies as a transformation prior to minimizing a Chi-Statistic. The end result is a slight nudge toward higher frequency values weighted toward similar values; in other words, it approximates taking the frequencies of two similar values and treats those values as one combined frequency when two values are relatively close to each other compared to other values in the distribution.</p>
		    				</Thumbnail>
		    			</Col>

		    			<Col xs={12} md={6}>
		    				<Thumbnail className="img-responsive center-block img-fluid" src={imgHeader_07}>
		    				<h3>Jackson Pollock</h3>
				          <p className="text-justify" style={fontSize}>This is the second RAM implemented in Karna-Ram. Jackson Pollock looks to minimize a Chi-Statistic by taking each measurement as categorical values and measuring each observed value in the dataset against every other observed value (as the expected value). This algorithm is designed to heavily weight values higher in frequency using a logarithmic technique weighted by frequency. The logic behind the underlying logarithmic approach is <em>inspired</em> by Alan Turing’s approach with respect to the logarithm of weight of evidence. Given two values with very similar frequencies, this algorithm will weight toward the numerically larger measurement.</p>
		    				</Thumbnail>
		    			</Col>
		    		</Row>

		    		<Row>
		    			<Col xs={12} md={12}>
		    				<Thumbnail>
		    				<h3>Claude Monet</h3>
				          <p className="text-justify" style={fontSize}>This is the third RAM to be implemented in Karna-Ram. While Leonardo da Vinci and Jackson Pollock use a Chi-Square approach, Claude Monet implements an actual Weight of Evidence (WoE) using the natural logarithm with an Information Value. In general Claude Monet and Leonardo da Vinci have similarities with respect to measurements being similar; likewise, Claude Monet and Jackson Pollock have similarities with respect to frequency. (<em><b>This feature is currently under development</b></em>)</p>

				          <ul>
					        	<li style={fontSize}>Turing's 'ban': the references above to Alan Turing are from his work at Bletchley Park. Turing expressed odds as logarithms and dubbed his unit for the logarithm of weight of evidence, the 'ban' as in Banbury. [2]</li>
					        </ul>
		    				</Thumbnail>
		    			</Col>
		    		</Row>
	    		</div>

	    		<Row>
	    			<Col xs={12} md={6}>
	    				<Thumbnail className="img-responsive center-block img-fluid" src={imgHeader_03}>
	    					<h3>Unicity Distance</h3>
			          <p className="text-justify" style={fontSize}>
			          	A way to quantify the relative value of a variable in a dataset using information theory where value is a function of cipher complexity. In cryptography, the unicity distance or point is the amount of cipher text needed to reduce the number of spurious keys in order to successfully decrypt a cipher text. "Unicity distance is not a measure of how much ciphertext is required for cryptanalysis, but how much ciphertext is required for there to be only one reasonable solution for cryptanalysis." [1] (p. 236) [Wikipedia: <a href="https://en.wikipedia.org/wiki/Unicity_distance">link</a>]</p>

		          	<p>
			            <Button bsStyle="primary" onClick={this.showUnicityDistance.bind(this)}>Modal Dialog</Button>
			          </p>
	    				</Thumbnail>
	    			</Col>

	    			<Col xs={12} md={6}>
	    				<Thumbnail className="img-responsive center-block img-fluid" src={imgHeader_04}>
	    					<h3>Depth</h3>
			          <p className="text-justify" style={fontSize}>
			          	Given two datasets with the same set of variables where the underlying illness, for example, is not known; Karna-Ram can calculate through a percent likelihood depth score whether the two sets of data are at depth. Depth, in this case, is defined in terms of cryptography whereby the two datasets exhibit similar frequency characteristics. This technique is based on William Friedman's original cryptologic index of coincidence [Recently Declassified NSA: <a href="https://www.nsa.gov/news-features/declassified-documents/friedman-documents/assets/files/publications/FOLDER_231/41760429079956.pdf">link</a>].
			          </p>

		          	<p>
			            <Button bsStyle="primary" onClick={this.showDepth.bind(this)}>Modal Dialog</Button>
			          </p>
	    				</Thumbnail>
	    			</Col>
	    		</Row>

	    		<Row>
	    			<Col xs={12} md={12}>
	    				<Thumbnail className="img-responsive center-block img-fluid" src={imgHeader_05}>
		    				<h3>Informatics-Diphthongs</h3>
			          <p className="text-justify" style={fontSize}>
			          	The vowel-like syllables of a dataset under a crypto-linguistic lens akin to a <a href="https://en.wikipedia.org/wiki/Bigram">bigram</a> or a <a href="https://en.wikipedia.org/wiki/Square_(cipher)">cipher square</a>. The values presented are the most statistically significant values calculated by the RAM (Rapid Analytical Machine). Karna-Ram uses famous painters to identify each RAM, in this case the RAM is Leonardo Da Vinci.</p>

			          <p className="text-justify" style={fontSize}>
			          	The real challenge was more about taking 2 variables with reasonably low uncertainty scores (<a href="https://en.wikipedia.org/wiki/Unicity_distance">unicity distance</a>) and creating a single conceptual variable. What I mean is something like variable A = 10 and variable B = 12. Taking those two variable values 10 &amp; 12 and building a single conceptual variable representative of the combination of 10 &amp; 12 such that variable Z is (A = 10 &amp; B = 12).
			          </p>
	    				</Thumbnail>
	    			</Col>
	    		</Row>

	    		<Row>
	    			<Col xs={12} md={6}>
	    				<Thumbnail className="img-responsive center-block img-fluid" src={imgHeader_08}>
		    				<h3>Pearson's Correlation Coefficient</h3>
			          <p className="text-justify" style={fontSize}>
			          	In matrix format, a standard Pearson's Correlation Coefficient identifying each variable in relation to every other variable. When I first began this project, I specifically wanted to look for relationships between variables within a dataset including the statistical correlations between values. Lime green are strong correlations, light green are moderate correlations, light pink are moderate negative correlations, and solid red are strong negative correlations. The Coefficient of Determination (R-Square) is in parenthesis.
			          </p>
	    				</Thumbnail>
	    			</Col>

	    			<Col xs={12} md={6}>
	    				<Thumbnail className="img-responsive center-block img-fluid" src={imgHeader_09}>
		    				<h3>Spearman's Rank-Order Coefficient</h3>
			          <p className="text-justify" style={fontSize}>
			          	As an alternative lens into variable correlations, I show a rank-order correlation coefficient called the Spearman's Rho. In order to normalize the rank, I decided to go with absolute distance from the mean using z-scores. This feature shows whether the ranking between two variables is correlated. Because of ties in rank, Pearson's Correlation Coefficient was used over the rankings instead of the more simple equation offered when distinct rank integers are available.
			          </p>
	    				</Thumbnail>
	    			</Col>
	    		</Row>

					<Row>
	    			<Col xs={12} md={6}>
	    				<Thumbnail className="img-responsive center-block img-fluid" src={imgHeader_10}>
		    				<h3>Stem-and-Leaf Plot</h3>
			          <p className="text-justify" style={fontSize}>
			          	Within the summary statistics tab, right-click launching a frequency distribution will show two distributions each with the same measurements and frequency data - the left grid shows a raw frequency chart and the right grid is a Stem-and-Leaf plot graphically visualizing the distribution.
			          </p>
	    				</Thumbnail>
	    			</Col>

	    			<Col xs={12} md={6}>
	    				<Thumbnail className="img-responsive center-block img-fluid" src={imgHeader_11}>
		    				<h3>Index of Significance</h3>
			          <p className="text-justify" style={fontSize}>
			          	Each RAM offers an index of significance and an index of resistance.  The index of significance are the most significant modeled values and the index of resistance are the least significant modeled values. When the indexes are within one standard deviation, I assign a color code.
			          </p>
	    				</Thumbnail>
	    			</Col>
	    		</Row>

	    		<Row>
	    			<Col xs={12} md={12}>
	    				<center>
		    				<MarketingBlock header="Current Features">
	    						<ul className={fontSize}>
						        <li>Data Import with Summary Statistics</li>
						        <ul>
						        	<li>Import supports unpacking delineated values embedded within existing data</li>
						        	<li>Summary statistics over both the raw imported data &amp; interquartile range</li>
						        	<li>Summary statistics:</li>
						        	<ul>
						        	<li>Mean, StDev, Variance, etc.</li>
						        	<li>Pearson's Correlation Coefficient Matrix</li>
						        	<ul>
						        		<li>Pearson correlation is a measure of linear association between the values of two variables (as opposed to rank).</li>
						        	</ul>
						        	<li>Spearman's Rank-Order Coefficient Matrix</li>
							        	<ul>
							        		<li>Spearman's Rho is a measure of linear association between the ranks of two variables (as opposed to value).</li>
							        	</ul>
						        	</ul>
						        </ul>
						        <li>Crypto Statistics</li>
						        <ul>
						        	<li>Minimum number of bits per variable (amount of information)</li>
						        	<li>Message Entropy H(<em>M</em>)</li>
						        	<li>Rate of Language (r) | H(<em>M</em>)/<em>N</em></li>
						        	<li>Absolute Rate of Language (R) | log<sub>2</sub> <em>L</em></li>
						        	<li>Redundancy <em>D</em> | <em>R</em> - <em>r</em></li>
						        	<li>Clinical Medicine: Entropy of a Cryptosystem: H(<em>K</em>) = Log<sub>2</sub> <em>K</em></li>
						        	<li>Clinical Medicine: Unicity Distance per variable: <em>U</em> = H(<em>K</em>)/<em>D</em></li>
						        </ul>
						        <li>RAM Implementation: Leonardo da Vinci</li>
						        <li>RAM Implementation: Jackson Pollock</li>
						        <li>Frequency Distribution with Stem-and-Leaf Plot</li>
						        <li>Depth Determination between Two Datasets</li>
						        <li>Data Export: CSV, XML, JSON (full export)</li>
						        <ul>
						        	<li>CSV: Comma Separated Value</li>
						        	<li>XML: Extensible Markup Language</li>
						        	<li>JSON: JavaScript Object Notation</li>
						        </ul>
						        <li>Data Export: Partial Single and Paired Datasets (CSV)</li>
						        <ul>
						        	<li>Helpful for t-test validation and experimentation</li>
						        </ul>
						        <li>Numeric Model Generation (all numeric combinations)</li>
						        <ul>
						        	<li>Designed to help the author investigate applied mathematical approaches with respect to every single numeric combination relevant to a clinical question.</li>
						        </ul>
					        </ul>
		    				</MarketingBlock>
	    				</center>
	    			</Col>
	    		</Row>

	    		<Row>
	    			<Col xs={12} md={12}>
	    				<center>
		    				<MarketingBlock header="Project Progress">
			    				<ul>
					        	<li>2017-11-21: Refactoring crypto statistics - supporting multiple cryptosystems where medicine is a cryptosystem</li>
					        	<li>2017-11-20: Introspection on Spearman's Rho Rank calculations for all values in each matrix correlation</li>
					        	<li>2017-11-19: Random depth score next to computed depth for each measurement variable for cross reference</li>
					        	<li>2017-11-17: Clinical Medicine as a Cryptosystem to support Entropy of a Cryptosystem &amp; Unicity Distance</li>
					        	<li>2017-11-16: Spearman's Rho Rank-Order Coefficient using z-score absolute distance from the mean as ranking</li>
					        	<li>2017-11-11: Fundamentals for Crypto-Statistics (information about each variable as a language)</li>
					        	<li>2017-11-10: Refactored internal data array matrix, added interquartile range tab with summary statistics</li>
					        	<li>2017-11-06: Refactored data export, using an interface supporting several classes now</li>
					        	<li>2017-11-05: Depth Measurement logic and tab (frequency comparison)</li>
					        </ul>
		    				</MarketingBlock>
	    				</center>
	    			</Col>
	    		</Row>

	    		<Row>
	    			<Col xs={12} md={12}>
	    				<center>
		    				<MarketingBlock header="References">
			    				[1] Schneier, B., Applied Cryptography : protocols, algorithms, and source code in C. 20th anniversary edition. ed. 2015, Indianapolis, IN: Wiley. xxv, 758 pages.
        					<br/>
        					[2] Budiansky, S., Code Warriors. 2016, New York: Alfred A. Knopf. xxi, 389 pages, 16 unnumbered pages of plates.
		    				</MarketingBlock>
	    				</center>
	    			</Col>
	    		</Row>

	    	</Grid>









	    	{
    			/**
    			 * Modal for Unicity Distance
    			 */
    		}

    		<Modal {...this.props}
        	show={this.state.showUnicityDistance}
        	onHide={this.hideUnicityDistance.bind(this)}
        	dialogClassName="modalUnicityDistance"
        	bsSize="lg">
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-lg"><h2>Unicity Distance</h2></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
            	<img class="img-responsive center-block img-fluid" alt="Unicity Distance" src={imgHeader_03} />
            </p>

            <ListGroup>
            	<ListGroupItem bsStyle="info" href="#" header="Medicine as a Cryptosystem">Platform currently supports: ICD-10-CM and ICD-10-International</ListGroupItem>

            	<ListGroupItem href="#" header="Biomedical Unicity Distance">Where clinical medicine is a cryptosystem, we can then interpret the biomedical unicity distance for a variable within an informatics dataset as representing the degree of complexity that variable serves to express. In general, assuming a non-cryptanalysis background, <b>this says that the greater the unicity distance, the more uncertain the variable is with respect to discovering a single diagnosis that explains that variable's value - it's a measure of uncertainty.</b></ListGroupItem>

            	<ListGroupItem href="#" header="Engineering Informatics">This same idea can be extended to <em>Engineering Informatics</em> with respect to investigating the cause of an incident. I liken this to building an aircraft where the engineering firm, such as <em><a href="https://www.lockheedmartin.com">Lockheed Martin</a></em>, investigates the cause of an engine malfunction during flight or a vibration in supersonic flight. This quantifies the question of uncertainty during analysis - how certain are we that <em>XYZ</em> variable played a role as a function of information theory.</ListGroupItem>

            	<ListGroupItem href="#" header="Quantifying Uncertainty">In terms of quantifying uncertainty - a technique similar to the weight of evidence (WoE) can be used for collecting data where buckets are defined based on time intervals. Observation data then is summed and stored in each bucket. With respect to military or law enforcement, we can define a variable as a geographic location. The cryptosystem in this context is quantified as the total number of potential geographic locations and the measurements are the summations within each bucket. This will provide a value of uncertainty for a geographic location associated with some observational data (such as mobile SAM location, criminal transaction location, etc).</ListGroupItem>
            </ListGroup>

          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="warning" onClick={this.hideUnicityDistance.bind(this)}>Close</Button>
          </Modal.Footer>
    		</Modal>

    		{
    			/**
    			 * Modal for Depth
    			 */
    		}

    		<Modal {...this.props}
        	show={this.state.showDepth}
        	onHide={this.hideDepth.bind(this)}
        	dialogClassName="modalDepth"
        	bsSize="lg">
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-lg"><h2>Depth</h2></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
            	<img class="img-responsive center-block img-fluid" alt="Depth" src={imgHeader_04} />
            </p>

            <ListGroup>
            	<ListGroupItem bsStyle="info" href="#" header="Depth Frequency">A percent likelihood depth score whether the two sets of data exhibit similar frequency characteristics: this is part of the 'RAM'.</ListGroupItem>

            	<ListGroupItem href="#" header="Patient Similarity">This technique can be used to look for similar patients exhibiting characteristically similar conditions during presentation. For example, it might be the case that two patient populations presenting with different diagnoses exhibit similar laboratory measurements; despite the different diagnoses, the two populations are said to be at depth from a measurement frequency point of view.</ListGroupItem>
            </ListGroup>

          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="warning" onClick={this.hideDepth.bind(this)}>Close</Button>
          </Modal.Footer>
    		</Modal>

    		{
    			/**
    			 * Modal for Informatics-Diphthongs
    			 */
    		}

    		<Modal {...this.props}
        	show={this.state.showDiphthongs}
        	onHide={this.hideDiphthongs.bind(this)}
        	dialogClassName="modalDiphthongs"
        	bsSize="lg">
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-lg"><h2>Informatics-Diphthongs</h2></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
            	<img class="img-responsive center-block img-fluid" alt="Informatics-Diphthongs" src={imgHeader_05} />
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="warning" onClick={this.hideDiphthongs.bind(this)}>Close</Button>
          </Modal.Footer>
    		</Modal>
    	</div>
		); // return
	} // render
} // class

/**
 * Expose default class
 */
export default KarnaRam;

/*
<ButtonGroup>
	<center>
	</center>
</ButtonGroup>

<center>
		    				<MarketingBlock header="Unicity Distance">
		    					<span style={fontSize}> a way to quantify the relative value of a variable in a dataset using information theory where value is a function of cipher complexity. In cryptography, the unicity distance or point is the amount of cipher text needed to reduce the number of spurious keys in order to successfully decrypt a cipher text. "Unicity distance is not a measure of how much ciphertext is required for cryptanalysis, but how much ciphertext is required for there to be only one reasonable solution for cryptanalysis." [1] (p. 236) [Wikipedia: <a href="https://en.wikipedia.org/wiki/Unicity_distance">link</a>]</span>
		    				</MarketingBlock>
	    				</center>

<center>
		    				<MarketingBlock header="Depth">
		    					<span style={fontSize}>Given two datasets with the same set of variables where the underlying illness, for example, is not known; Karna-Ram can approximate through a percent likelihood depth score whether the two sets of data are at depth. Depth, in this case, is defined in terms of cryptography whereby the two datasets exhibit the similar frequency characteristics. This can be used to look for similar patients exhibiting characteristically similar conditions. This technique is based on William Friedman's original cryptologic index of coincidence [NSA: <a href="https://www.nsa.gov/news-features/declassified-documents/friedman-documents/assets/files/publications/FOLDER_231/41760429079956.pdf">link</a>].</span>
		    				</MarketingBlock>
	    				</center>
*/


// WEBPACK FOOTER //
// ./src/cba/appspec/body/KarnaRam.js